// Delete file when cleaning up jira_theming_relay_migration
import { memo, useEffect } from 'react';
import { graphql, useFragment } from 'react-relay';
import { useAnalyticsEvents, fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { useThemeSetting } from '@atlassian/jira-project-theme-providers/src/controllers/theme/index.tsx';
import type { ThemeEvaluated$key } from '@atlassian/jira-relay/src/__generated__/ThemeEvaluated.graphql';

const ThemeEvaluated = ({ projectRef }: { projectRef: ThemeEvaluated$key }) => {
	const data = useFragment<ThemeEvaluated$key>(
		graphql`
			fragment ThemeEvaluated on JiraProject {
				projectType
				projectId
			}
		`,
		projectRef,
	);
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const [theme] = useThemeSetting();
	useEffect(() => {
		if (data.projectType === 'BUSINESS') {
			fireTrackAnalytics(createAnalyticsEvent({}), 'theme evaluated', {
				theme: theme?.value,
				projectId: data?.projectId,
			});
		}
	}, [theme?.value, data.projectType, data?.projectId, createAnalyticsEvent]);

	return null;
};

export default memo(ThemeEvaluated);
